import React from 'react'
import { MonitorOrdenes } from './Ordenes/MonitorOrdenes'

export const PrincipalDesktopOrdenes = () => {return (<MonitorOrdenes />)}